import React, { Component } from 'react';
import CustomLoader from '../../common/Loader';
import { Link } from 'react-router-dom';
import { getDataSources, removeSource } from '../../../services/dataSourceService';
import { SourceTypes } from '../../../constants/DatasourceTypes';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';

class DataSource extends Component {
	constructor(props) {
		super(props);

		this.state = {
			DataSources: [],
			loading: false,
		};
	}

	async componentDidMount() {
		this.setState({ loading: true });

		const { data: DataSources } = await getDataSources();
		this.setState({ DataSources, loading: false });
	}

	getSourceBadge(type) {
		return type === SourceTypes.Database ? 'badge badge-teal mr-1' : 'badge badge-teal mr-2';
	}

	handleRemove = async (Source_ID) => {
		const { DataSources: oldDataSources } = this.state;
		const { data } = await removeSource(Source_ID);
		if (data.includes('removed')) {
			const DataSources = oldDataSources.filter((source) => source.DataSource_ID !== Source_ID);
			this.setState({ DataSources });
			toaster('success', data);
			logActivity('/dataSource', 'DATASOURCE_DELETE_SUCCESS');
		} else {
			toaster('error', data);
			logActivity('/dataSource', 'DATASOURCE_DELETE_FAILED');
		}
	};

	render() {
		const { DataSources, loading } = this.state;
		if (loading) {
			return <CustomLoader loading={loading} />;
		}

		return (
			<React.Fragment>
				<div className='container'>
					<h2 className='mb-0 mt-5'>Data Sources</h2>
					<hr className='mt-2 mb-4' />
					<div className='card card-icon mb-4'>
						<div className='row no-gutters'>
							<div className='col-auto card-icon-aside bg-primary'>
								<button
									className='btn btn-blue'
									onClick={() => {
										this.props.history.push('/dataSourceSettings');
									}}
								>
									+ New Source
								</button>
							</div>
							<div className='col'>
								<div className='card-body py-5'>
									{DataSources.map((source, idx) => {
										return (
											<React.Fragment key={source.DataSource_ID}>
												<div className='d-flex align-items-center justify-content-between'>
													<div className='d-flex align-items-center'>
														<div className={this.getSourceBadge(source.DataSource_Type_ID)}>{source.DataSource_Type_Name}</div>
														<div className='ml-4'>
															<div>
																<Link
																	to={{
																		pathname: '/dataSourceSettings/',
																		DataSource_ID: source.DataSource_ID,
																		DataSource_Type_ID: source.DataSource_Type_ID,
																	}}
																>
																	{source.Description}
																</Link>
															</div>
															{/* <div className="text-xs text-muted">
                                {source.Connection_String}
                              </div> */}
														</div>
													</div>
													<button className='btn btn-outline-danger btn-sm' onClick={() => this.handleRemove(source.DataSource_ID)}>
														Delete
													</button>
												</div>
												{idx !== DataSources.length - 1 && <hr />}
											</React.Fragment>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				</div>
				<ToastContainer/>
			</React.Fragment>
		);
	}
}

export default DataSource;
